import { useEffect, useState } from "react";
import Moment from 'moment';
import { CarouselCaption, CarouselItem } from "reactstrap";
import { GetClientes, GetProductos } from "../components/queries/Queries";
//import { Storage } from 'aws-amplify';
import { getUrl, list, uploadData } from "@aws-amplify/storage";
import { createProducto, updateProducto } from '../graphql/mutations';
import { guardarProductos } from "../components/queries/Mutations";
import { generateClient } from "aws-amplify/api";

const API = generateClient();

//Variables que almacenan los datos del cliente
const initialFormState = {
    clienteID: '', numerodeParte: '', descripcion: '', activo: true, divisa: 'Dólar', precioUnitario: '', precioUnitarioPC: '',
    precioUnitarioP: '', rackTipo: '', cantidadporAnio: '', documentodeEspecificaciones: '', Reg_Ins_Usuario: '',
    Reg_Mod_Usuario: '', image: '', image1: '', image2: '', image3: '', image4: '', image5: '', image6: '', image7: '',
    image8: '', image9: '', numerodeParteSalida: '', poEmbarques: '', clienteAsociadoID: "", numerodeParteAsociado: ""
}
const initialImages = { image: [], image1: [], image2: [], image3: [], image4: [], image5: [], image6: [], image7: [], image8: [], image9: [] }
const initialDocuments = {
    documentodeEspecificaciones: [], documento1: [], documento2: [], documento3: [], documento4: [], documento5: [],
    documento6: [], documento7: [], documento8: [], documento9: []
}

const initialfFormState = { formType: 'Catálogo' }

export default function useProductos() {
    //Declaración de variables
    const [clientes, setClientes] = useState([]);
    const [productos, setProductos] = useState([]);
    const [productosSinFiltro, setProductosSinFiltro] = useState([]);
    const [mProductos, setMProductos] = useState([]);
    const [formState, updateFormState] = useState(initialfFormState);
    const [formData, updateFormData] = useState(initialFormState);
    const [formImages, updateFormImages] = useState(initialImages);
    const [formDocuments, updateDocuments] = useState(initialDocuments);
    const [isDisabled, setisDisabled] = useState(false);
    const [estadoCliente, setEstadoCliente] = useState("todos");
    const [clienteName, setClienteName] = useState("");
    const [clienteID, setClienteID] = useState("");
    const [search, setSearch] = useState("");
    const [searchBy, setSearchBy] = useState("número de parte");
    const [estadoProductos, setEstadoProductos] = useState("Todos");
    const [totalRecords, setTotalRecords] = useState(0);
    const [clienteActivo, setClienteActivo] = useState(false);
    const [cargando, setCargando] = useState(false);
    const { formType } = formState;
    const [mensajeAlert, setMensajeAlert] = useState("Hola");
    const [color, setColor] = useState("warning");
    const userName = window.$name;
    const pproductos = window.$Productos ? window.$Productos : false;
    const vpreciounitario = window.$VerPrecioUnitario ? window.$VerPrecioUnitario : false;
    const [aVisible, setAVisible] = useState(false);
    const [imagenn, setImagenn] = useState(1);
    const [documenton, setDocumenton] = useState(1);
    const [editarArchivo, setEditarArchivo] = useState(false);
    const [mostrarproducto, setMostrarProducto] = useState(false);
    const [imagenRepetida, setImagenRepetida] = useState(false);
    const [DocumentoRepetido, setDocumentoRepetido] = useState(false);
    const [items, setItems] = useState([]);
    const onDismiss = () => setAVisible(false);
    Moment.locale('en');

    // current page
    const [currentPage, setCurrentPage] = useState(1);

    // total records per page to display
    const recordPerPage = 20;

    // total number of the records
    //const totalRecords = 40;

    // range of pages in paginator
    const pageRange = 5;

    // handle change event
    function handlePageChange(pageNumber) {
        setAVisible(false);
        setCargando(false);
        setCurrentPage(pageNumber);
        busqueda(productosSinFiltro, searchBy, search, estadoProductos, pageNumber);
    }
    //Slider
    const [activeIndex, setActiveIndex] = useState(0);
    const [animating, setAnimating] = useState(false);

    const next = () => {
        if (animating) return;
        const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
        setActiveIndex(nextIndex);
    }

    const previous = () => {
        if (animating) return;
        const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
        setActiveIndex(nextIndex);
    }

    const goToIndex = (newIndex) => {
        if (animating) return;
        setActiveIndex(newIndex);
    }

    const slides = items.map((item) => {
        return (
            <CarouselItem
                onExiting={() => setAnimating(true)}
                onExited={() => setAnimating(false)}
                key={item.src}
            >
                <img src={item.src} alt={item.altText} width="300px" className="conteinercarouselimg" />
                <CarouselCaption className="text-muted" captionText={item.caption} captionHeader={item.altText} />
            </CarouselItem>
        );
    });
    //Slider fin    


    //Método useEffect
    useEffect(() => {
        fetchClientes();
    }, []);

    async function onChangeimage(e) {
        setMensajeAlert("Revisando si el archivo ya existe");
        setColor("primary");
        setCargando(true);
        setAVisible(false);
        window.scrollTo(0, 0);
        setImagenRepetida(true);
        setisDisabled(true);
        if (!e.target.files[0]) {
            setImagenRepetida(false);
            if (!DocumentoRepetido)
                setisDisabled(false);
            setAVisible(false);
            setCargando(false);
            return
        }
        const file = e.target.files[0];
        const imageexist = await list({ path: "public/" + file.name });//await Storage.list(file.name);
        if (imageexist.items.length === 0) {
            setImagenRepetida(false);
            if (!DocumentoRepetido)
                setisDisabled(false);
            setAVisible(false);
            setCargando(false);
            updateFormImages(() => ({ ...formImages, [e.target.name]: file }));
            updateFormData(() => ({ ...formData, [e.target.name]: file.name }));
        } else {
            setImagenRepetida(true);
            setMensajeAlert("Ya existe una imagen con el mismo nombre: favor de seleccionar otra imagen o cambiar el nombre de la imagen y volver a intentarlo: ");
            setColor("warning");
            setCargando(false);
            setAVisible(true);
            window.scrollTo(0, 0);
        }
    }
    //Guarda el archivo seleccionado
    async function onChangedocumento(e) {
        setMensajeAlert("Revisando si el archivo ya existe");
        setColor("primary");
        setCargando(true);
        setAVisible(false);
        window.scrollTo(0, 0);
        setDocumentoRepetido(true);
        setisDisabled(true);
        if (!e.target.files[0]) {
            setDocumentoRepetido(false);
            if (!imagenRepetida)
                setisDisabled(false);
            setAVisible(false);
            setCargando(false);
            updateDocuments(() => ({ ...formDocuments, [e.target.name]: [] }));
            updateFormData(() => ({ ...formData, [e.target.name]: "" }));
            return
        }
        const file = e.target.files[0];
        const documentesxists = await list({ path: "public/" + file.name });//await Storage.list(file.name);
        if (documentesxists.items.length === 0) {
            setDocumentoRepetido(false);
            if (!imagenRepetida)
                setisDisabled(false);
            setAVisible(false);
            setCargando(false);
            updateDocuments(() => ({ ...formDocuments, [e.target.name]: file }));
            updateFormData(() => ({ ...formData, [e.target.name]: file.name }));
            //Mensaje de ayuda al desarrollador
            /*setMensajeAlert([e.target.name] + ': ' + file.name);
            setColor("primary");*/
            setAVisible(false);
            setCargando(false);
            window.scrollTo(0, 0);
        } else {
            setDocumentoRepetido(true);
            setMensajeAlert("Ya existe un archivo con el mismo nombre: favor de seleccionar otro archivo o cambiar el nombre y volver a intentarlo: ");
            setColor("warning");
            setCargando(false);
            setAVisible(true);
            window.scrollTo(0, 0);
        }

        //setEditarArchivo(true);
        //updateFormData({ ...formData, documentodeEspecificaciones: file.name });         
        //await Storage.put(file.name, file);           
    }
    //Evento que revisa el cambio en la búsqueda
    function onSearch(e) {
        setAVisible(false);
        setCargando(false);
        busqueda(productosSinFiltro, searchBy, search, estadoProductos, currentPage);
    }
    //Evento que revisa el cambio en tipo de búsqueda
    function onSearchBy(e) {
        setAVisible(false);
        setCargando(false);
        setSearchBy(e.target.value);
        if (search)
            busqueda(productosSinFiltro, e.target.value, search, estadoProductos, currentPage);
    }
    //Evento que revisa el cambio en el filtro por estado del cliente
    function onEstadoProductos(e) {
        setAVisible(false);
        setCargando(false);
        setEstadoProductos(e.target.value);
        busqueda(productosSinFiltro, searchBy, search, e.target.value, currentPage);
    }

    //Obtiene el estado seleccionado en el combo de mostrando clientes
    function sClienteEstado(e) {
        e.persist()
        setEstadoCliente(e.target.value);
        setAVisible(false);
        setCargando(false);
    }
    //función para la búsqueda
    async function busqueda(productossinf, searchByp, searchp, estadoprotucto, currentPage) {
        var pag = 1;
        var bandera = 1;
        //Filtrado de datos por la búsqueda y el estado del producto
        const productosFromAPI = productossinf.sort((a, b) =>
            a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0).filter(producto =>
                searchByp === "número de parte" ? producto.numerodeParte.toLowerCase().includes(searchp.toLowerCase()) :
                    producto.descripcion.toLowerCase().includes(searchp.toLowerCase())).filter(producto =>
                        estadoprotucto === "inactivos" ? producto.activo === false : estadoprotucto === "activos" ? producto.activo === true : producto.activo === producto.activo);
        await Promise.all(productosFromAPI.map(async producto => {
            producto.indexpag = pag;
            bandera++;
            if (bandera > recordPerPage) {
                bandera = 1;
                pag++;
            }

            return producto;
        }))

        const lengthproductos = productosFromAPI.length;
        if (lengthproductos <= 0)
            setCurrentPage(1);

        setProductos(productosFromAPI.filter(producto => producto.indexpag === currentPage).sort((a, b) =>
            a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0));
        setTotalRecords(lengthproductos);

        if (currentPage > 1 && lengthproductos > 0) {
            const prepaginas = parseInt(lengthproductos / recordPerPage);
            const paginas = prepaginas * recordPerPage < lengthproductos ? prepaginas + 1 : prepaginas;
            if (currentPage > paginas) {
                setCurrentPage(paginas);
                const productosFromAPIp = productosFromAPI.sort((a, b) =>
                    a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0).filter(producto =>
                        producto.indexpag === paginas);
                setProductos(productosFromAPIp.sort((a, b) =>
                    a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0));
            }
        }
    }

    //Obtiene los datos guardados de los clientes
    async function fetchClientes() {
        //Se obtienen los datos de los clientes
        setCargando(true);
        const apiData = await GetClientes();

        const clientesFromAPI = apiData;
        await Promise.all(clientesFromAPI.map(async cliente => {
            if (cliente.image) {
                const image = await getUrl({ key: cliente.image });//await Storage.get(cliente.image);
                cliente.image = image.url.toString();
            }
            return cliente;
        }))
        setClientes(apiData);
        setCargando(false);
    }

    //Obtiene los datos guardados de los productos
    async function fetchProductos(claveCliente, searchByp, searchp, estadoprotucto) {
        //const Avisible=aVisible;
        setCargando(true);
        //setAVisible(false);
        //Filtro por cliente 
        let filter = {
            clienteID: {
                eq: claveCliente
            }
        }

        var pag = 1;
        var bandera = 1;
        //Se obtienen los datos de los productos por clave del cliente
        const apiData = await GetProductos(filter);
        //Filtrado de datos por la búsqueda y el estado del producto
        const productosFromAPI = apiData.filter(producto =>
            searchByp === "número de parte" ? producto.numerodeParte.toLowerCase().includes(searchp.toLowerCase()) :
                producto.descripcion.toLowerCase().includes(searchp.toLowerCase())).filter(producto =>
                    estadoprotucto === "inactivos" ? producto.activo === false : estadoprotucto === "activos" ? producto.activo === true : producto.activo === producto.activo);
        await Promise.all(productosFromAPI.map(async producto => {
            //Imagenes
            if (producto.image) {
                const image = await getUrl({ key: producto.image });//await Storage.get(producto.image);
                producto.imagename = producto.image;
                producto.image = image.url.toString();
            }
            if (producto.image1) {
                const image1 = await getUrl({ key: producto.image1 });//await Storage.get(producto.image1);
                producto.imagename1 = producto.image1;
                producto.image1 = image1.url.toString();
            }
            if (producto.image2) {
                const image2 = await getUrl({ key: producto.image2 });//await Storage.get(producto.image2);
                producto.imagename2 = producto.image2;
                producto.image2 = image2.url.toString();
            }
            if (producto.image3) {
                const image3 = await getUrl({ key: producto.image3 });//await Storage.get(producto.image3);
                producto.imagename3 = producto.image3;
                producto.image3 = image3.url.toString();
            }
            if (producto.image4) {
                const image4 = await getUrl({ key: producto.image4 });//await Storage.get(producto.image4);
                producto.imagename4 = producto.image4;
                producto.image4 = image4.url.toString();
            }
            if (producto.image5) {
                const image5 = await getUrl({ key: producto.image5 });//await Storage.get(producto.image5);
                producto.imagename5 = producto.image5;
                producto.image5 = image5.url.toString();
            }
            if (producto.image6) {
                const image6 = await getUrl({ key: producto.image6 });//await Storage.get(producto.image6);
                producto.imagename6 = producto.image6;
                producto.image6 = image6.url.toString();
            }
            if (producto.image7) {
                const image7 = await getUrl({ key: producto.image7 });//await Storage.get(producto.image7);
                producto.imagename7 = producto.image7;

                producto.image7 = image7.url.toString();
            }
            if (producto.image8) {
                const image8 = await getUrl({ key: producto.image8 });//await Storage.get(producto.image8);
                producto.imagename8 = producto.image8;
                producto.image8 = image8.url.toString();
            }
            if (producto.image9) {
                const image9 = await getUrl({ key: producto.image9 });//await Storage.get(producto.image9);
                producto.imagename9 = producto.image9;
                producto.image9 = image9.url.toString();
            }
            //Documentos
            if (producto.documentodeEspecificaciones) {
                const documento = await getUrl({ key: producto.documentodeEspecificaciones });//await Storage.get(producto.documentodeEspecificaciones);
                producto.documentodeEspecificacionesurl = documento.url.toString();
            }
            if (producto.documento1) {
                const documento1 = await getUrl({ key: producto.documento1 });//await Storage.get(producto.documento1);
                producto.documento1url = documento1.url.toString();
            }
            if (producto.documento2) {
                const documento2 = await getUrl({ key: producto.documento2 });//await Storage.get(producto.documento2);
                producto.documento2url = documento2.url.toString();
            }
            if (producto.documento3) {
                const documento3 = await getUrl({ key: producto.documento3 });//await Storage.get(producto.documento3);
                producto.documento3url = documento3.url.toString();
            }
            if (producto.documento4) {
                const documento4 = await getUrl({ key: producto.documento4 });//await Storage.get(producto.documento4);
                producto.documento4url = documento4.url.toString();
            }
            if (producto.documento5) {
                const documento5 = await getUrl({ key: producto.documento5 });//await Storage.get(producto.documento5);
                producto.documento5url = documento5.url.toString();
            }
            if (producto.documento6) {
                const documento6 = await getUrl({ key: producto.documento6 });//await Storage.get(producto.documento6);
                producto.documento6url = documento6.url.toString();
            }
            if (producto.documento7) {
                const documento7 = await getUrl({ key: producto.documento7 });//await Storage.get(producto.documento7);
                producto.documento7url = documento7.url.toString();
            }
            if (producto.documento8) {
                const documento8 = await getUrl({ key: producto.documento8 });//await Storage.get(producto.documento8);
                producto.documento8url = documento8.url.toString();
            }
            if (producto.documento9) {
                const documento9 = await getUrl({ key: producto.documento9 });//await Storage.get(producto.documento9);
                producto.documento9url = documento9.url.toString();
            }
            //producto.indexnum=bandera;
            producto.indexpag = pag;
            bandera++;
            if (bandera > recordPerPage) {
                bandera = 1;
                pag++;
            }

            return producto;
        }))

        setProductosSinFiltro(productosFromAPI);

        busqueda(productosFromAPI, searchBy, search, estadoProductos, currentPage);
        setCargando(false);
        //setAVisible(Avisible);
    }

    //Revisa cambios en los inputs
    function onChanges(e) {
        e.persist()
        const re = /^[0-9\.]+$/;
        if (e.target.name === "precioUnitario" || e.target.name === "cantidadporAnio" || e.target.name === "piezasXRack") {
            if (e.target.value === '' || re.test(e.target.value)) {
                updateFormData(() => ({ ...formData, [e.target.name]: e.target.value }));
            }

        } else
            updateFormData(() => ({ ...formData, [e.target.name]: e.target.value }));
    }
    function onChangescheck(e) {
        if (e.target.checked === false) {
            if (e.target.name === "Ecoat") {
                updateFormData(() => ({ ...formData, [e.target.name]: e.target.checked, precioUnitario: "" }));
            } else if (e.target.name === "Pcoat") {
                updateFormData(() => ({ ...formData, [e.target.name]: e.target.checked, precioUnitarioPC: "" }));
            } else if (e.target.name === "Platinado") {
                updateFormData(() => ({ ...formData, [e.target.name]: e.target.checked, precioUnitarioP: "" }));
            } else {
                updateFormData(() => ({ ...formData, [e.target.name]: e.target.checked }));
            }
        } else {
            updateFormData(() => ({ ...formData, [e.target.name]: e.target.checked }));
        }

    }
    //Guarda los datos de los productos
    async function createProductos() {
        setAVisible(false);
        setCargando(true);
        setisDisabled(true);
        window.scrollTo(0, 0);
        const productoCreado = await guardarProductos(formData, imagenRepetida, DocumentoRepetido, formImages, formDocuments, false);
        setMensajeAlert(productoCreado.mensaje);
        setColor(productoCreado.color);
        setCargando(false);
        setAVisible(true);
        setisDisabled(productoCreado.deshabilitarBoton);
        if (productoCreado.completo === true) {
            updateFormImages(initialImages);
            updateDocuments(initialDocuments);
            updateFormData(initialFormState);
            if (clienteName) {
                fetchProductos(clienteID, searchBy, search, estadoProductos);
                updateFormState(() => ({ ...formState, formType: "Catálogo - " + clienteName }));
            } else {
                setCurrentPage(1);
                fetchClientes();
                updateFormState(() => ({ ...formState, formType: "Catálogo" }));
            }
        }
    }

    //Guarda los datos de los productos
    async function updateProductos() {
        setAVisible(false);
        setCargando(false);
        setisDisabled(true);
        try {
            if (!formData.clienteID || !formData.numerodeParte || !formData.divisa ||
                (!formData.Pcoat && !formData.Ecoat && !formData.Platinado) ||
                (formData.Pcoat && !formData.precioUnitarioPC) || (formData.Ecoat && !formData.precioUnitario) ||
                (formData.Platinado && !formData.precioUnitarioP) || formData.cantidadporAnio === '' || formData.rackTipo === '') {
                setMensajeAlert("Faltan datos: los campos marcados con un astirisco son obligatorios");
                /*setMensajeAlert("Faltan datos: los campos marcados con un astirisco son obligatorios: ClienteID " + formData.clienteID + 
                ", Numero de parte " +  formData.numerodeParte +", divisa " + formData.divisa + ", precioUnitario " +formData.precioUnitario +
                ", cantidadporaño " + formData.cantidadporAnio);*/
                setColor("warning");
                setisDisabled(false);
                setAVisible(true);
                window.scrollTo(0, 0);
            } else {
                if (mProductos !== formData) {
                    //Se revisa si hay concurrencia.
                    let filter = {
                        id: {
                            eq: formData.id
                        }
                    };
                    const dataFromAPI = await GetProductos(filter);
                    //Si la fecha de actualización es la misma, no hay concurrencia y se procede con la modificación 
                    if (dataFromAPI[0].updatedAt === formData.updatedAt) {
                        delete formData.createdAt;
                        delete formData.updatedAt;
                        delete formData.__typename;
                        //Imagenes
                        if (formData.imagename) {
                            delete formData.imagename;
                        }
                        if (formData.imagename1) {
                            delete formData.imagename1;
                        }
                        if (formData.imagename2) {
                            delete formData.imagename2;
                        }
                        if (formData.imagename3) {
                            delete formData.imagename3;
                        }
                        if (formData.imagename4) {
                            delete formData.imagename4;
                        }
                        if (formData.imagename5) {
                            delete formData.imagename5;
                        }
                        if (formData.imagename6) {
                            delete formData.imagename6;
                        }
                        if (formData.imagename7) {
                            delete formData.imagename7;
                        }
                        if (formData.imagename8) {
                            delete formData.imagename8;
                        }
                        if (formData.imagename9) {
                            delete formData.imagename9;
                        }
                        delete formData.indexpag;
                        delete formData.documentodeEspecificacionesurl;

                        if (!formImages.image.name) {
                            delete formData.image;
                        } else {
                            await uploadData({ key: formImages.image.name, data: formImages.image });
                        }
                        if (!formImages.image1.name) {
                            delete formData.image1;
                        } else {
                            await uploadData({ key: formImages.image1.name, data: formImages.image1 });
                        }
                        if (!formImages.image2.name) {
                            delete formData.image2;
                        } else {
                            await uploadData({ key: formImages.image2.name, data: formImages.image2 });
                        }
                        if (!formImages.image3.name) {
                            delete formData.image3;
                        } else {
                            await uploadData({ key: formImages.image3.name, data: formImages.image3 });
                        }
                        if (!formImages.image4.name) {
                            delete formData.image4;
                        } else {
                            await uploadData({ key: formImages.image4.name, data: formImages.image4 });
                        }
                        if (!formImages.image5.name) {
                            delete formData.image5;
                        } else {
                            await uploadData({ key: formImages.image5.name, data: formImages.image5 });
                        }
                        if (!formImages.image6.name) {
                            delete formData.image6;
                        } else {
                            await uploadData({ key: formImages.image6.name, data: formImages.image6 });
                        }
                        if (!formImages.image7.name) {
                            delete formData.image7;
                        } else {
                            await uploadData({ key: formImages.image7.name, data: formImages.image7 });
                        }
                        if (!formImages.image8.name) {
                            delete formData.image8;
                        } else {
                            await uploadData({ key: formImages.image8.name, data: formImages.image8 });
                        }
                        //Documentos
                        if (formData.documentodeEspecificacionesurl) { delete formData.documentodeEspecificacionesurl; }
                        if (formData.documento1url) { delete formData.documento1url; }
                        if (formData.documento2url) { delete formData.documento2url; }
                        if (formData.documento3url) { delete formData.documento3url; }
                        if (formData.documento4url) { delete formData.documento4url; }
                        if (formData.documento5url) { delete formData.documento5url; }
                        if (formData.documento6url) { delete formData.documento6url; }
                        if (formData.documento7url) { delete formData.documento7url; }
                        if (formData.documento8url) { delete formData.documento8url; }
                        if (formData.documento9url) { delete formData.documento9url; }

                        if (!formDocuments.documentodeEspecificaciones || !formData.documentodeEspecificaciones) {
                            delete formData.documentodeEspecificaciones;
                        } else {
                            await uploadData({ key: formDocuments.documentodeEspecificaciones.name, data: formDocuments.documentodeEspecificaciones });
                        }
                        if (!formDocuments.documento1 || !formData.documento1) {
                            delete formData.documento1;
                        } else {
                            await uploadData({ key: formDocuments.documento1.name, data: formDocuments.documento1 });
                        }
                        if (!formDocuments.documento2 || !formData.documento2) {
                            delete formData.documento2;
                        } else {
                            await uploadData({ key: formDocuments.documento2.name, data: formDocuments.documento2 });
                        }
                        if (!formDocuments.documento3 || !formData.documento3) {
                            delete formData.documento3;
                        } else {
                            await uploadData({ key: formDocuments.documento3.name, data: formDocuments.documento3 });
                        }
                        if (!formDocuments.documento4 || !formData.documento4) {
                            delete formData.documento4;
                        } else {
                            await uploadData({ key: formDocuments.documento4.name, data: formDocuments.documento4 });
                        }
                        if (!formDocuments.documento5 || !formData.documento5) {
                            delete formData.documento5;
                        } else {
                            await uploadData({ key: formDocuments.documento5.name, data: formDocuments.documento5 });
                        }
                        if (!formDocuments.documento6 || !formData.documento6) {
                            delete formData.documento6;
                        } else {
                            await uploadData({ key: formDocuments.documento6.name, data: formDocuments.documento6 });
                        }
                        if (!formDocuments.documento7 || !formData.documento7) {
                            delete formData.documento7;
                        } else {
                            await uploadData({ key: formDocuments.documento7.name, data: formDocuments.documento7 });
                        }
                        if (!formDocuments.documento8 || !formData.documento8) {
                            delete formData.documento8;
                        } else {
                            await uploadData({ key: formDocuments.documento8.name, data: formDocuments.documento8 });
                        }
                        if (!formDocuments.documento9 || !formData.documento9) {
                            delete formData.documento9;
                        } else {
                            await uploadData({ key: formDocuments.documento9.name, data: formDocuments.documento9 });
                        }
                        // setMensajeAlert("Problemas al guardar los datos del producto " + formData);
                        await API.graphql({ query: updateProducto, variables: { input: formData } });

                        setMensajeAlert("Datos guardados");
                        setColor("primary");
                        setCargando(false);
                        setAVisible(true);
                        setEditarArchivo(false);
                        //setProductos([ ...productos, formData ]);             
                        updateFormData(initialFormState);
                        updateFormImages(initialImages);
                        updateDocuments(initialDocuments);
                        fetchProductos(clienteID, searchBy, search, estadoProductos);
                        updateFormState(() => ({ ...formState, formType: "Catálogo - " + clienteName }));
                    } else { //Si la fecha es diferente significa que sí hay concurrencia y que se tienen que actualizar los datos
                        window.scrollTo(0, 0);
                        /*setMensajeAlert("No fue posible realizar la operación: existe concurrencia, se requiere cancelar la operación y " + 
                        " volver a intentarlo, revisando fecha: " + dataFromAPI[0].updatedAt + ", fecha de registro actual: "+ formData.updatedAt +
                        ", id: " + formData.id);*/
                        setMensajeAlert("No fue posible realizar la operación: existe concurrencia, se requiere cancelar la operación y " +
                            " volver a intentarlo");
                        setColor("warning");
                        setCargando(false);
                        setAVisible(true);
                        //fetchProductos(clienteID, searchBy, search, estadoProductos); 
                    }
                } else {
                    setMensajeAlert("No se detectaron cambios");
                    setColor("primary");
                    setCargando(false);
                    setAVisible(true);
                    setEditarArchivo(false);
                    //setProductos([ ...productos, formData ]);            
                    updateFormData(initialFormState);
                    fetchProductos(clienteID, searchBy, search, estadoProductos);
                    updateFormState(() => ({ ...formState, formType: "Catálogo - " + clienteName }));

                }
            }
        } catch (e) {
            window.scrollTo(0, 0);
            setEditarArchivo(false);
            //updateFormData(initialFormState);
            setMensajeAlert("No fue posible realizar la operación: favor de comunicarse a sistemas");
            setColor("warning");
            setCargando(false);
            setAVisible(true);
            setisDisabled(false);
        }
    }

    //Prepara los datos del producto para mostrarlos
    function onClickProducto(producto) {
        setMostrarProducto(true);
        setAVisible(false);
        setCargando(false);
        updateFormData(producto);
        setMProductos(producto);
        //Imágenes 
        var listitems = [];
        var imagenes = 1;
        listitems.push({ src: producto.image, altText: producto.imagename });
        if (producto.imagename1) {
            listitems.push({ src: producto.image1, altText: producto.imagename1 });
            imagenes = 2;
        }
        if (producto.imagename2) {
            listitems.push({ src: producto.image2, altText: producto.imagename2 });
            imagenes = 3;
        }
        if (producto.imagename3) {
            listitems.push({ src: producto.image3, altText: producto.imagename3 });
            imagenes = 4;
        }
        if (producto.imagename4) {
            listitems.push({ src: producto.image4, altText: producto.imagename4 });
            imagenes = 5;
        }
        if (producto.imagename5) {
            listitems.push({ src: producto.image5, altText: producto.imagename5 });
            imagenes = 6;
        }
        if (producto.imagename6) {
            listitems.push({ src: producto.image6, altText: producto.imagename6 });
            imagenes = 7;
        }
        if (producto.imagename7) {
            listitems.push({ src: producto.image7, altText: producto.imagename7 });
            imagenes = 8;
        }
        if (producto.imagename8) {
            listitems.push({ src: producto.image8, altText: producto.imagename8 });
            imagenes = 9;
        }
        if (producto.imagename9) {
            listitems.push({ src: producto.image9, altText: producto.imagename9 });
            imagenes = 10;
        }
        //Documentos
        var documentos = 1;
        if (producto.documento1) documentos = 2;
        if (producto.documento2) documentos = 3;
        if (producto.documento3) documentos = 4;
        if (producto.documento4) documentos = 5;
        if (producto.documento5) documentos = 6;
        if (producto.documento6) documentos = 7;
        if (producto.documento7) documentos = 8;
        if (producto.documento8) documentos = 9;
        if (producto.documento9) documentos = 10;

        setImagenn(imagenes);
        setItems(listitems);
        setDocumenton(documentos);
    }

    //Prepara los datos del cliente para mostrarlos
    function onClickCliente(nombreCliente, claveCliente, clienteActivo) {
        setAVisible(false);
        setCargando(false);
        setMostrarProducto(false);
        setClienteID(claveCliente);
        setTotalRecords(0);
        setClienteName(nombreCliente);
        setClienteActivo(clienteActivo);
        setEditarArchivo(false);
        //setSearchBy("número de parte");      
        updateFormData({ ...formData, clienteID: claveCliente });
        fetchProductos(claveCliente, searchBy, search, estadoProductos);
        updateFormState(() => ({ ...formState, formType: "Catálogo - " + nombreCliente }));
    }

    function regresarCliente() {
        setAVisible(false);
        setCargando(false);
        setMostrarProducto(false);
        setEditarArchivo(false);
        busqueda(productosSinFiltro, searchBy, search, estadoProductos, currentPage);
        updateFormState(() => ({ ...formState, formType: "Catálogo - " + clienteName }));
    }
    //Envía al formulario para crear un nuevo producto
    async function nuevoProducto(cliente) {
        setImagenn(1);
        setDocumenton(1);
        setisDisabled(false);
        setAVisible(false);
        if (cliente === false)
            updateFormData({ ...initialFormState, Reg_Ins_Usuario: userName, precioUnitario: '', cantidadporAnio: '' });
        else
            updateFormData({ ...initialFormState, clienteID: clienteID, Reg_Ins_Usuario: userName, precioUnitario: '', cantidadporAnio: '' });
        updateFormState(() => ({ ...formState, formType: "Nuevo Producto" }));
    }
    //Envía al formulario de Catálogo
    function catalogo() {
        updateFormData(initialFormState);
        setAVisible(false);
        setMostrarProducto(false);
        setEditarArchivo(false);
        setClienteID("");
        setSearch("");
        setSearchBy("número de parte");
        setEstadoProductos("todos");
        setClienteName("");
        setProductos([]);
        setTotalRecords(0);
        setCurrentPage(1);
        setEstadoCliente("todos");
        //updateFormData({ ...formData, clienteID: "" }); 
        updateFormState(() => ({ ...formState, formType: "Catálogo" }));
    }
    //Envía al formulario de Editar producto
    function editarProducto() {
        setisDisabled(false);
        setAVisible(false);
        setCargando(false);
        setMostrarProducto(false);
        updateFormData({ ...formData, Ecoat: formData.Ecoat ? formData.Ecoat : formData.precioUnitario ? true : false, Reg_Mod_Usuario: userName });
        updateFormState(() => ({ ...formState, formType: "Editar Producto" }));
    }

    return {
        pproductos,
        vpreciounitario,
        formType,
        color,
        aVisible,
        mensajeAlert,
        cargando,
        clienteName,
        mostrarproducto,
        clienteActivo,
        searchBy,
        estadoProductos,
        clientes,
        estadoCliente,
        search,
        productos,
        clienteID,
        totalRecords,
        currentPage,
        recordPerPage,
        pageRange,
        formData,
        activeIndex,
        items,
        slides,
        imagenn,
        documenton,
        isDisabled,
        formImages,
        editarArchivo,
        editarProducto,
        catalogo,
        onDismiss,
        onSearchBy,
        nuevoProducto,
        onEstadoProductos,
        setSearch,
        onSearch,
        onClickProducto,
        fetchProductos,
        handlePageChange,
        regresarCliente,
        next,
        previous,
        goToIndex,
        onChanges,
        onChangescheck,
        onChangeimage,
        onChangedocumento,
        setImagenn,
        setDocumenton,
        onClickCliente,
        sClienteEstado,
        createProductos,
        updateProductos
    };
};